import Home from './Home.js';

class Motion {

  /**
   * Constructor
   */
  constructor(){
    // Properties
    this.test = "test";
    this.rects = [];
    this.init();
    this.loopRect = {};
    this.mouseOverBorderListener = [];
    this.mouseOutBorderListener = [];

    // left: 37, up: 38, right: 39, down: 40,
    // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
    this.keys = {37: 1, 38: 1, 39: 1, 40: 1};
  }

  /**
   * init
   */
  init(){
    console.log('init motion');
  }


  /**
   * LOCK/UNLOCK methods
   */
  displayLockingMask(){
    console.log("display locking mask");
    var loadMask = document.getElementById('lock');
    var maskTimeline = new TimelineLite();
    maskTimeline.set(loadMask, {
      width:"100%", // set width to 0 in 0ms
      onComplete: function(){
        maskTimeline.to(loadMask, 0.3, {opacity:1}); // disappear in 300ms
      }
    });
  }
  animatePageRemoval(){
    console.log('animate page removal');
    var pageContainer = document.getElementById("page-header-container").nextElementSibling;
    TweenLite.to(pageContainer, 0.2, {
      opacity: 0,
      top: "30px",
      ease: Power1.easeOut
    });
  }
  hideLockingMask(){
    console.log("remove loading mask");
    var loadMask = document.getElementById('lock');
    var maskTimeline = new TimelineLite();
    maskTimeline.to(loadMask, 0.4, {opacity:0}); // disappear in 300ms
    maskTimeline.set(loadMask, {
      width:0, // set width to 0 in 0ms
    });
  }
  animatePageAddition(){
    console.log('animate page addition');
    var pageContainer = document.getElementById("page-header-container").nextElementSibling;
    pageContainer.style.opacity = "1";
    TweenLite.to(pageContainer, 0.3, {
      opacity: 1,
      top: 0,
      ease: Power1.easeOut,
      onComplete: function(){
        console.log('refresh display');
        var e = document.createEvent('UIEvents');
        e.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(e);
      }
    });
  }
  animateFilterLock(){
    var listContainer = document.getElementById("realisations-realisations-list");
    TweenLite.to(listContainer, 0.5, {
      opacity: 0.3,
      ease: Power1.easeOut,
    });
  }
  animateFilterUnlock(){
  }


  /**
   * disable/enables scroll methods
   */
  disableScroll() {
    console.log('disable scroll');
    if (window.addEventListener) // older FF
      window.addEventListener('DOMMouseScroll', this.preventDefault, false);
    window.onwheel = this.preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
    window.ontouchmove  = this.preventDefault; // mobile
    document.onkeydown  = this.preventDefaultForScrollKeys;
  }
  enableScroll() {
    console.log('enable scroll');
    if (window.removeEventListener)
      window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }
  preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
      e.preventDefault();
    e.returnValue = false;
  }
  preventDefaultForScrollKeys(e) {
    if (this.keys[e.keyCode]) {
      this.preventDefault(e);
      return false;
    }
  }


  /**
   * PAGE INIT methods
   */
  animateRemove(){
    console.log("remove loading mask");
    var loadMask = document.getElementById('load');
    var maskTimeline = new TimelineLite();
    maskTimeline.to(loadMask, 0.3, {opacity:0}); // disappear in 300ms
    maskTimeline.set(loadMask, {
      width:0, // set width to 0 in 0ms
      onComplete: function(){
        document.body.removeChild(loadMask);
        var e = document.createEvent('UIEvents');
        e.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(e);
        window.scroll(0,0);
        this.enableScroll();
      }.bind(this)
    })
  }


  /**
   * Animate borders
   * @TODO: Refactor
   */
  animateBorders(){
    var self = this;
    // @TODO: Separate addListeners and update on page change
    self.rects = document.getElementsByClassName("border-fill-button");
    for(var i=0; i<self.rects.length; i++) {
      self.rects[i].tl = new TimelineLite();
      self.rects[i].animationTarget
        = self.rects[i].getElementsByTagName('rect')[0];
      self.rects[i].tl.set(self.rects[i].animationTarget, {
        attr:{
          'stroke-dashoffset':
            self.rects[i].animationTarget.getAttribute('stroke-dashoffset')
        },
        ease: Sine.easeInOut,
      });
      self.rects[i].tl.to(self.rects[i].animationTarget, 0.5, {
        attr:{'stroke-dashoffset': 0},
        ease: Sine.easeInOut,
      });
      self.rects[i].tl.pause(); // init display
      self.rects[i].addEventListener("mouseover", function( event ) {
        this.tl.play();
      }.bind(self.rects[i]), false);
      self.rects[i].addEventListener("mouseout", function( event ) {
        this.tl.reverse();
      }.bind(self.rects[i]), false);
    }
  }
  initBorders(){
    this.rects = document.getElementsByClassName("border-fill-button");
    this.initBordersListeners();
  }
  refreshBordersListeners(){
    this.initBordersListeners();
  }
  initBordersListeners(){
    for(var i=0; i<this.rects.length; i++) {
      if(this.rects[i].getAttribute('data-border') !== "set") {
        this.rects[i].setAttribute('data-border', "set");
        this.rects[i].tl = new TimelineLite();
        this.rects[i].animationTarget
          = this.rects[i].getElementsByTagName('rect')[0];
        this.rects[i].tl.set(this.rects[i].animationTarget, {
          attr:{
            'stroke-dashoffset':
              this.rects[i].animationTarget.getAttribute('stroke-dashoffset')
          },
          ease: Sine.easeInOut,
        });
        this.rects[i].tl.to(this.rects[i].animationTarget, 0.5, {
          attr:{'stroke-dashoffset': 0},
          ease: Sine.easeInOut,
        });
        this.rects[i].tl.pause(); // init display
        this.mouseOverBorderListener = this.mouseOverBorder.bind(this.rects[i]);
        this.mouseOutBorderListener = this.mouseOutBorder.bind(this.rects[i]);
        this.rects[i].addEventListener(
            "mouseover",
            this.mouseOverBorderListener,
            false
            );
        this.rects[i].addEventListener(
            "mouseout",
            this.mouseOutBorderListener,
            false
            );
      }
    }
  }
  mouseOverBorder(e){
    this.tl.play();
  }
  mouseOutBorder(e){
    this.tl.reverse();
  }


  /**
   * HOMEPAGE INIT methods
   */
  animateHome(){
    console.log('init animate home full');
    var self = this;
    window.addEventListener("load", function() {
      self.animatePanel();
    });
  }
  animatePanel(){
    var self = this;
    // loading mask timeline
    var loadMask = document.getElementById('load');
    var maskTimeline = new TimelineLite();
    self.hideStuff();
    console.log("loading timeout - have to find better solution");
    setTimeout(function(){
      console.log("loading timeout is over");
      self.initStuff();
      var htmlContainer = document.getElementsByTagName("html")[0];
      maskTimeline.to(loadMask, 0.3, {opacity:0}); // disappear in 300ms
      maskTimeline.set(loadMask, {display:"none"})
        htmlContainer.style.height = "100%";
      htmlContainer.style.overflowY = "auto";
      htmlContainer.style.position = "static";
      self.displayTweens();
    }, 1000);
  }
  hideStuff(){
    console.log('pass hide');
    var htmlContainer = document.getElementsByTagName("html")[0];
    console.log('lock screen');
    htmlContainer.style.height = "100%";
    htmlContainer.style.overflowY = "scroll";
    htmlContainer.style.position = "fixed";
    window.scroll(0,0);
  }
  initStuff(){
    console.log("init containers opacity");
    document.getElementById("home-intro").style.opacity = "0";
    document.getElementById("home-intro").style.left = "50px";
    document.getElementById("home-realisations-list").style.opacity = "0";
    document.getElementById("home-realisations-list").style.left = "50px";
    document.getElementById("home-content-left").style.opacity = "0";
    document.getElementById("home-content-left").style.left = "50px";
    document.getElementById("home-magazine-container").style.opacity = "0";
    document.getElementById("home-magazine-container").style.left = "50px";
    document.getElementById("home-about").style.opacity = "0";
    document.getElementById("home-about").style.left= "50px";
    document.getElementById("home-contact").style.opacity = "0";
    document.getElementById("home-contact").style.left = "50px";
  }
  displayTweens(){
    console.log("display after load tweens");
    var homeTweensTimeline = new TimelineLite();
    homeTweensTimeline.to(document.getElementById("home-intro"), 0.3, {
      opacity: 1,
      left: 0,
      ease: Power1.easeOut
    }, "+=0.5");
    homeTweensTimeline.to(
      document.getElementById("home-realisations-list"),
      0.3,
      {
        opacity: 1,
        left: 0,
        ease: Power1.easeOut,
        onComplete: function(){
          this.enableScroll();
        }.bind(this)
      }
    );
  }
  listenToScroll(){
    if (document.getElementById('lock').offsetWidth == 0) {
      var scrollPosition = window.innerHeight + window.pageYOffset;
      var homeContentLeftOffset
        = document.getElementById("home-content-left").offsetTop;
      var homeAboutOffset = document.getElementById("home-about").offsetTop;
      var homeContactOffset = document.getElementById("home-contact").offsetTop;
      var facilitator = window.innerHeight/3;
      var trigger1 = homeContentLeftOffset + facilitator;
      var trigger2 = homeAboutOffset + facilitator;
      var trigger3 = homeContactOffset + facilitator;
      if (scrollPosition > trigger1 && !self.trigg1Loaded) {
        console.log("LOAD TRIGGER 1");
        self.trigg1Loaded = true;
        TweenLite.to(document.getElementById("home-content-left"), 0.3, {
          opacity: 1,
          left: 0,
          ease: Power1.easeOut
        });
        TweenLite.to(document.getElementById("home-magazine-container"), 0.3, {
          opacity: 1,
          left: 0,
          ease: Power1.easeOut
        });
        // BAD DUPLICATE OF MAG RESIZE METHOD
        if(window.innerWidth >= 1024) {
          var test = document.getElementById('home-content').offsetHeight;
          document.getElementById('home-magazine-container').style.height = test + "px";
        } else {
          document.getElementById('home-magazine-container').style.height = "auto";
        }
      }
      if (scrollPosition > trigger2 && !self.trigg2Loaded) {
        console.log("LOAD TRIGGER 2");
        self.trigg2Loaded = true;
        TweenLite.to(document.getElementById("home-about"), 0.3, {
          opacity: 1,
          left: 0,
          ease: Power1.easeOut
        });
      }
      if (scrollPosition > trigger3 && !self.trigg3Loaded) {
        console.log("LOAD TRIGGER 3");
        self.trigg3Loaded = true;
        TweenLite.to(document.getElementById("home-contact"), 0.3, {
          opacity: 1,
          left: 0,
          ease: Power1.easeOut
        });
      }
    }
  }


  /**
   * CONTACTPAGE INIT methods
   */
  scrollToContact(){
    if(document.getElementById("home-contact-container")) {
      TweenLite.to(
          window,
          0.5,
          {
            scrollTo:"#home-contact-container",
            ease:Cubic.easeInOut
          }
          );
    }
  }


  /**
   * REALISATIONSPAGE INIT methods
   */
  showPagination(list,realisationsListTemplate){
    var container = document.createElement("ul");
    container.style.opacity = "0";
    container.innerHTML = realisationsListTemplate;
    var spinner = document.getElementById('realisations-spinner');
    // insert container before spinner
    list.insertBefore(container, spinner)
    var paginationTimeline = new TimelineLite();
    spinner.style.display = "none";
    paginationTimeline.fromTo(
        container,
        0.3,
        {marginTop:"50px"},
        {opacity:1,marginTop:0}
        );
  }


  /**
   * Mouse over on Realisations List Item
   */
  /*
  mouseOverRealisationsListItem(e) {
    var title = this.getElementsByTagName('span')[0];
		TweenLite.to(title, 0.3, {opacity: 1});
		TweenLite.to(this, 0.3, {css:{
      scaleX:1.02,
      scaleY:1.02
		}});
  }
  mouseOutRealisationsListItem(e) {
    var title = this.getElementsByTagName('span')[0];
		TweenLite.to(title, 0.3, {opacity: 0});
		TweenLite.to(this, 0.3, {css:{
      scaleX:1,
      scaleY:1
		}});
  }
  initRealisationsListStyle() {
    var realisationsListAnchors
      = document.getElementById("realisations-realisations-list")
      .getElementsByTagName('a');
    for(var i=0, len=realisationsListAnchors.length; i<len; i++){
      realisationsListAnchors[i].getElementsByTagName('span')[0].style.opacity = "0";
      realisationsListAnchors[i].style.scaleX = "1";
      realisationsListAnchors[i].style.scaleY = "1";
    }
  }*/


}

export default Motion;
